module.exports = __webpack_public_path__ + "static/sophia-757dec14bf013a24b4a9e40e44fa6e2f.png";